module.exports = __webpack_public_path__ + "img/vip-coupon.d554647f.png";